module.exports = __webpack_public_path__ + "img/subject4_05.jpg";